import { cn, STATUS_STYLES } from "@/lib/utils";

export default function StatusBadge({ status, className }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.new;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-xs font-medium",
        s.bg,
        s.text,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {s.label}
    </span>
  );
}
